import { render } from "./BlockContacts.vue?vue&type=template&id=75f01af2&scoped=true"
import script from "./BlockContacts.vue?vue&type=script&lang=js"
export * from "./BlockContacts.vue?vue&type=script&lang=js"

import "./BlockContacts.vue?vue&type=style&index=0&id=75f01af2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f01af2"]])

export default __exports__